import React from "react";
import { Link } from "react-router-dom";
import { Mail, Linkedin, Phone, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="mt-32 border-t border-[var(--border-soft)] bg-[var(--surface)] relative">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <h3 className="font-display text-3xl md:text-4xl font-light leading-tight">
            Let&apos;s build something <em className="font-medium">delightful</em>.
          </h3>
          <p className="mt-4 text-[var(--text-muted)] max-w-sm">A product enthusiast in love with shipping experiences that move metrics and minds.</p>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[var(--text-muted)]">Navigate</p>
          <div className="mt-4 flex flex-col gap-2 font-medium">
            <Link to="/about" data-testid="footer-link-about" className="hover:text-[var(--peach)]">About</Link>
            <Link to="/experience" data-testid="footer-link-experience" className="hover:text-[var(--peach)]">Experience</Link>
            <Link to="/projects" data-testid="footer-link-projects" className="hover:text-[var(--peach)]">Projects</Link>
            <Link to="/contact" data-testid="footer-link-contact" className="hover:text-[var(--peach)]">Contact</Link>
          </div>
        </div>
        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[var(--text-muted)]">Reach out</p>
          <div className="mt-4 flex flex-col gap-2.5">
            <a data-testid="footer-email" href="mailto:nikitasingh2027@gmail.com" className="inline-flex items-center gap-2 group">
              <Mail className="w-4 h-4 text-[var(--text-muted)]" />
              <span>nikitasingh2027@gmail.com</span>
              <ArrowUpRight className="w-3.5 h-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />
            </a>
            <a data-testid="footer-linkedin" href="https://www.linkedin.com/in/nikita-singh-a4702625a" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 group">
              <Linkedin className="w-4 h-4 text-[var(--text-muted)]" />
              <span>LinkedIn</span>
              <ArrowUpRight className="w-3.5 h-3.5 opacity-0 group-hover:opacity-100 transition-opacity" />
            </a>
            <a data-testid="footer-phone" href="tel:+917024878835" className="inline-flex items-center gap-2 group">
              <Phone className="w-4 h-4 text-[var(--text-muted)]" />
              <span>+91 7024 878 835</span>
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-[var(--border-soft)] py-6 text-center text-xs font-medium text-[var(--text-muted)]">
        © {new Date().getFullYear()} Nikita Singh · Crafted with care
      </div>
    </footer>
  );
}
